import { VenturePrivacySettings } from '@src/app/shared/enums/venture.enum';

export const CbChartaProjectIdeaDisplayProperties = [
  'GraueTreibhausgaseErstellungRueckbau',
  'Kreislauffaehigkeit',
  'PrimaerRohstoff',
];

export const venturePrivacySettingsAttribute = {
  selectionType: 'Radio',
  frequentlyUsedChoice: [],
  attributeType: 'SingleSelection',
  propertyName: 'PrivacySettings',
  displayName: 'Select Privacy Options',
  apiType: 'Selection',
  systemType: 'Selection',
  isCustomAttribute: false,
  isVisibleInPortal: true,
  isVisibleInPortalList: true,
  isVisibleInSystem: false,
  isVisibleInSystemList: false,
  choice: {
    codeId: 'VenturePrivacySettings',
    name: 'Project Idea Privacy Settings',
    selections: [
      {
        codeId: 'Public',
        value: 'Public',
        order: 0,
        masterCodeId: null,
        helpTextId: 'UI.Venture.Privacy.Public.Hint',
      },
      {
        codeId: 'PublicWithLimitedInfo',
        value: 'Public and limited information',
        order: 1,
        masterCodeId: null,
        helpTextId: 'UI.Venture.Privacy.PublicLimited.Hint',
      },
      {
        codeId: 'Private',
        value: 'Private',
        order: 2,
        masterCodeId: null,
        helpTextId: 'UI.Venture.Privacy.Private.Hint',
      },
      {
        codeId: 'PrivateWithLimitedInfo',
        value: 'Private and limited information',
        order: 3,
        masterCodeId: null,
        helpTextId: 'UI.Venture.Privacy.PrivateLimited.Hint',
      },
    ],
    masterCodeId: null,
  },
  defaultValue: {
    codeId: 'Public',
    value: 'Public',
    order: 0,
    masterCodeId: null,
  },
  regularExpression: null,
  required: true,
  type: 'System',
  readOnly: false,
  helpTextId: '',
  uiControlId: '',
  validationErrorTextId: '',
  sortable: false,
  isCalculatedAttribute: false,
  isCustomDisplayAttribute: false,
};

// Map venture privacy to venture IsPrivate and IsNDARequired
export const venturePrivacyMapping = {
  [VenturePrivacySettings.Public]: [false, false],
  [VenturePrivacySettings.PublicWithLimitedInfo]: [false, true],
  [VenturePrivacySettings.Private]: [true, false],
  [VenturePrivacySettings.PrivateWithLimitedInfo]: [true, true],
};
